import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  neolexonIndicator: {
    backgroundColor: colors.newUI.therapist.green70,
    padding: 5,
    borderBottomLeftRadius: 24,
    borderTopLeftRadius: 24,
    paddingRight: 22,
    justifyContent: 'center',
  },
  labelWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    borderRadius: 24,
    alignItems: 'center',
    paddingHorizontal: 10,
    minHeight: 28,
  },
});
